import React, { useEffect } from "react";

import { wrap } from "./RydTestbedWrap";
import TimeSignatureInputBox from "../components/ContextTimeSignature";
import { MetronomeActivityIndicator, MetronomeInputBox } from "../components/pickers/ContextMetronome";
import { MetronomeMarking, NoteDuration, TimeSignature } from "../model/core";
import { Metronome } from "../model/metronome";
import { playMetronome, stopMetronome } from "../audio/AudioController";

function makeLine(pattern: Metronome.BeatPattern, s: Metronome.BeatStrenght) {
    return (
        <tr key={s}>
            <td>{s}</td>
            {pattern.map((beat, i) => (
                <td key={i} className={beat === s ? 'active' : ''}>{beat === s ? 'x' : ''}</td>
            ))}
        </tr>
    );
}

const bs: Metronome.BeatStrenght[] = ['strong', 'weak'];

export function MetronomePatternTestbed() {

    const [timeSignature, setTimeSignature] = React.useState<TimeSignature>(new TimeSignature(4, 4));
    const [metronome, setMetronome] = React.useState<MetronomeMarking>(new MetronomeMarking(120, NoteDuration.fromTimeSignature(timeSignature.denominator)));
    const [metronomePattern, setMetronomePattern] = React.useState<Metronome.BeatPattern>(Metronome.makeMetronomeBeatSequence(timeSignature));

    useEffect(() => {
        if (timeSignature && metronome) {
            setMetronomePattern(Metronome.makeMetronomeBeatSequence(timeSignature));
        }
    }, [timeSignature, metronome]);

    console.log('MetronomePatternTestbed', timeSignature, metronome, metronomePattern);

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>MetronomePattern Testbed</h1>

        <TimeSignatureInputBox
            timeSignature={timeSignature}
            setTimeSignatureCB={(ts: TimeSignature) => {
                setTimeSignature(ts);
            }}
        />
        <MetronomeInputBox
            metronome={metronome}
            setMetronomeCB={(m: MetronomeMarking) => {
                setMetronome(m);
            }}
        />

        <div>
            Duration from timeSignature: {NoteDuration.fromTimeSignature(timeSignature.denominator).getDurationName()}<br />

            <table>
                <tbody>
                    {bs.map((s) => makeLine(metronomePattern, s))}
                </tbody>
            </table>

            <button onClick={() => playMetronome(
                metronomePattern,
                metronome,
                1
            )}>Play</button>
            <button onClick={stopMetronome}>Stop</button>

            <MetronomeActivityIndicator
                metronomeActivityObserver={Metronome.ActivityObserver.getInstance()}
            />

        </div>
    </>);
}